<div class="container" style="margin-top: 126px;">
    <div class="row mt-4">
        <ng-container *ngIf="!ProductDetail || !productLoaded; else productTemplate">
          <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
            <div class="synch-carousels">
              <div class="left child">
                <ngx-slick-carousel #slickModal="slick-carousel" class="carousel thumbs gallery" [config]="thumbSlider">
                  <div ngxSlickItem *ngFor="
                      let item of skeletonService.generateFake(4);
                      let i = index
                    " class="item">
                    <ngx-skeleton height="30px"></ngx-skeleton>
                    <ngx-skeleton height="30px"></ngx-skeleton>
                    <ngx-skeleton height="30px"></ngx-skeleton>
                    <ngx-skeleton height="30px"></ngx-skeleton>
                  </div>
                </ngx-slick-carousel>
              </div>
              <div class="right child text-center">
                <ngx-skeleton height="400px"></ngx-skeleton>
              </div>
            </div>

            <div class="row mt-4 book-btn-padding d-none d-md-flex">
              <div class="col-12 col-lg-6 mb-2 mb-lg-0">
                <ngx-skeleton height="50px"></ngx-skeleton>
              </div>
              <div class="col-12 col-lg-6">
                <ngx-skeleton height="50px"></ngx-skeleton>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
            <div class="product-details-wrapper">
              <h3 class="product-name align-items-start">
                <ngx-skeleton height="30px" style="width: 100%"></ngx-skeleton>
              </h3>
              <div class="rating">
                <ngx-skeleton height="30px" style="width: 100%"></ngx-skeleton>
              </div>
              <div class="price d-lg-flex">
                <ngx-skeleton height="45px" style="width: 100%"></ngx-skeleton>
              </div>
              <div class="avail-offer">
                <ngx-skeleton height="20px" style="width: 100%"> </ngx-skeleton>
              </div>
              <div class="finance-offer">
                <div class="offer-header">
                  <ngx-skeleton height="140px" style="width: 100%"></ngx-skeleton>
                </div>
              </div>

              <div class="row mt-4 d-flex">
                <div class="col-6 col-lg-6 mb-2 mb-lg-0">
                  <ngx-skeleton height="25px" style="width: 50%"></ngx-skeleton>
                </div>
                <div class="col-6 col-lg-6">
                  <ngx-skeleton height="25px" style="width: 50%"></ngx-skeleton>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
         <ng-template #productTemplate>
          <div class="row mt-4">
            <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 position-relative">
              <div class="synch-carousels">
                <div class="left child">
                  <img (click)="prevSlide()"  *ngIf="ProductDetail?.vehicle_documents?.length > 5" style="cursor: pointer"
                    alt="top-blue-arrow" [src]="
                      environment1 + 'images/PDP-Images/pdp-arrows/top-blue-arrow.svg'
                    " />
                  <ngx-slick-carousel #slickModal="slick-carousel" class="carousel thumbs gallery" [config]="thumbSlider"
                    style="height: 389px">
                    <div ngxSlickItem *ngFor="let item of (ProductDetail?.vehicle_documents.length ? ProductDetail?.vehicle_documents : [{ path: defaultImage }])" class="item">
                      <img style="cursor: pointer" src="{{ item.path }}"
                        (click)="changeslide(ProductDetail?.vehicle_documents?.path.indexOf(item))"
                        class="img-fluid" loading="lazy" />
                    </div>
                  </ngx-slick-carousel>
                  <img (click)="nextSlide()" *ngIf="ProductDetail?.vehicle_documents?.length > 5"  style="cursor: pointer"
                    alt="down-blue-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/down-blue-arrow.svg'
                    " />
                </div>
                <div class="right child text-center">
                  <ngx-slick-carousel #slickHLModal="slick-carousel" class="carousel imagepreview right gallery2"
                    (click)="imagePreviewpopup()" [config]="imageSlider">
                    <div ngxSlickItem *ngFor="let item of (ProductDetail?.vehicle_documents.length ? ProductDetail?.vehicle_documents : [{ path: defaultImage }])" class="item">
                    <div class="tagf"> <span class="badge bg-primary"><img class="eye" [src]='environment1 + "assets/images/eye.png"' alt=""> {{ProductDetail?.view_count}} Views </span></div>
                    <span class="shareicon1 d-block d-md-none">
                      <a href="javascript:void(0);" (click)="openSocialSharePopup()">
                        <img alt="social-share-icon" [src]="
                            environment1 + 'images/PDP-Images/social-share-icon.svg'
                          " loading="lazy" />
                      </a>
                    </span>
                    <span class="shareicon2 d-block d-md-none">

                    </span>

                          <img
                          src="{{ item.path }}"
                          alt="tataok"
                          class="img-fluid img-size image-containe magnify"
                          (mousemove)="onMouseMove($event, $event.currentTarget)"
                          (mouseleave)="onMouseLeave($event.currentTarget)"
                          style="cursor: crosshair;"
                          loading="lazy"
                        />

                        <div class="align-items-center tagftataok" *ngIf="ProductDetail.vehicle_certificate_type == 'Certified'">
                          <img class="tataok  " [src]='environment1 + "assets/images/tata-ok.png"' alt="">
                          <span class="text-white">Refurbished</span>
                        </div>
                    </div>
                  </ngx-slick-carousel>
                </div>
              </div>
              <span class="d-md-none mobile-wish d-none">
                <a href="javascript:void(0);" (click)="openSocialSharePopup()">
                  <img alt="social-share-icon" [src]="environment1 + 'images/PDP-Images/social-share-icon.svg'"
                    loading="lazy" />
                </a>
              </span>
            </div>
          <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
            <div class="product-details-wrapper">
              <h1 class="product-name align-items-start">
               {{ProductDetail.model}}
                <div class="ms-auto utility-btn">
                  <span class="d-block d-md-block">
                    <a href="javascript:void(0);" (click)="openSocialSharePopup()">
                      <img alt="social-share-icon" [src]="
                          environment1 + 'images/PDP-Images/social-share-icon.svg'
                        " loading="lazy" />
                    </a>
                  </span>
                  <button style="
                      width: 24px;
                      height: 24px;
                      border: none;
                      background-color: transparent;
                    ">

                  </button>
                </div>
              </h1>

              <div class="datacolumns row">
                <div class="d-flex col-12  d1" style="justify-content: space-between;">
                  <p class="col-4">State</p>
                  <p class="col-4">District</p>
                  <p class="col-4">Owner</p>
              </div>
              <div class="d-flex col-12 d2" style="justify-content: space-between;">
                  <p class="col-4">{{ProductDetail?.state}}</p>
                  <p class="col-4">{{ProductDetail?.district ? (ProductDetail?.district  | titlecase) : ''}}</p>
                  <p class="col-4">{{getFirstPartOfOwners(ProductDetail.no_of_owners)}}</p>
              </div>
              <div class="d-flex col-12  d1" style="justify-content: space-between;">
                  <p class="col-4">Year</p>
                  <p class="col-4">Fuel Type</p>
                  <p class="col-4">KMs</p>
              </div>

              <div class="d-flex col-12 d2 " style="justify-content: space-between;">
                  <p class="col-4">{{ProductDetail.year_of_manufacture}}</p>
                  <p class="col-4">{{ProductDetail.fuel_type}}</p>
                  <p class="col-4">{{ProductDetail.odometer ? (ProductDetail.odometer |  number:'1.0-0') : ''}}</p>
              </div>
              </div>
              <div class="price d-lg-flex" *ngIf="ProductDetail.dealer_suggestive_price">
                {{
                  ProductDetail.dealer_suggestive_price > 999
                    ? (ProductDetail.dealer_suggestive_price | currency: 'INR': 'symbol': '4.0-0')
                    : (ProductDetail.dealer_suggestive_price | currency: 'INR': 'symbol': '1.0-0')
                }}
                <span class="text-nowrap d-block d-lg-flex" *ngIf="ProductDetail.engine_warranty === 'Yes'">Warranty available</span>
              </div>
              <div class="price d-lg-flex d-block" *ngIf="!ProductDetail.dealer_suggestive_price">
                <span style="font-size: 25px;color:black;font-weight: 600;">Please contact to Dealer.</span>
              </div>

              <div class="userdata">
                <form [formGroup]="userFormpdp">
                  <div class="row d-flex" *ngIf="isUserLoggedIn">
                    <div class="col-12 col-lg-6 col-sm-12">
                      <label class="mend">Name </label>
                          <input  type="text" class="form-control h-48" formControlName="name" placeholder="Enter Name"
                             (keydown)="notAllowSpace($event)" [ngClass]="{
                              'disabled': userData?.first_name || userData?.last_name
                            }" />
                             <div *ngIf="userFormpdp.controls['name'].invalid && (userFormpdp.controls['name'].dirty || userFormpdp.controls['name'].touched)">
                              <div *ngIf="userFormpdp.controls['name'].errors?.required" class="text-danger">Name is required.</div>
                            </div>
                    </div>
                    <div class="col-12 col-lg-6 col-sm-12" *ngIf="isUserLoggedIn">
                      <label class="mend">Contact Info</label>
                      <div class="form-input">
                        <div class="country-code">
                          <div class="nation-flag">
                            <img alt="Nation Flag" [src]='environment1 + "assets/images/ind-flag.svg"' class="img-fluid" loading="lazy"/>
                          </div>
                          +91
                        </div>
                        <input formControlName="contact" type="tel"  class="mobile_no"
                          maxlength="10" placeholder="Mobile Number" numbersOnly [ngClass]="{
                            'disabled': userData?.mobile_number
                          }" />

                      </div>
                      <div *ngIf="userFormpdp.controls['contact'].invalid && (userFormpdp.controls['contact'].dirty || userFormpdp.controls['contact'].touched)">
                        <div *ngIf="userFormpdp.controls['contact'].errors?.required" class="text-danger">Contact number is required.</div>
                        <div *ngIf="userFormpdp.controls['contact'].errors?.pattern" class="text-danger">Contact number must be 10 digits long.</div>
                      </div>
                    </div>
                  </div>
                  <div class="row col-12 mt-3" *ngIf="isUserLoggedIn">
                    <div class="col-12 col-lg-6 col-sm-12">
                    <label>Do you need financing ? </label>
                    <div class="mt-3">
                      <input id="subscription" type="radio" formControlName="consent" value="yes"> Yes
                      <input id="subscription" class="ps-2" type="radio" formControlName="consent" value="no"> No
                    </div>
                    <div *ngIf="userFormpdp.controls['consent'].invalid && (userFormpdp.controls['consent'].dirty || userFormpdp.controls['consent'].touched)">
                      <div *ngIf="userFormpdp.controls['consent'].errors?.required" class="text-danger">consent choice is required.</div>
                    </div>
                    <div class="form-check mt-2">
                      <input  class="form-check-input consent-box" type="checkbox" value="" id="defaultCheck1" #myCheckbox (change)="onCheckboxChange(myCheckbox.checked)">
                      <label class="form-check-label" for="defaultCheck1">
                        Consent to allow TATA Motors to contact you
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-sm-12" *ngIf="ProductDetail?.user?.organization_name || ProductDetail?.dealer_contact_number">
                    <p>Dealer name : {{ProductDetail?.user?.organization_name}}</p>
                    <p>Dealer Contact : {{DealermoileNo}}</p>
                  </div>
                  </div>
                  <div class="col-12 mt-3">
                 <button id="otpVerification" class="btn col-12 btn-primary  btn-grad-primary btn-brand h-48 " [disabled]="isUserLoggedIn && userFormpdp.invalid" [ngClass]="{'disabled': !checkBoxcheked && isUserLoggedIn}" data-bs-toggle="modal" [attr.data-bs-target]="isUserLoggedIn ? null : '#loginDealer'" (click)="onSubmit()">Submit Enquiry</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        </ng-template>
    </div>
    <div>
     <app-emi-calculator  *ngIf="productPrice" [productPrice]="productPrice"
     [loan]="productPrice"></app-emi-calculator>
    </div>
     <div *ngIf="ProductDetail?.cat?.id && ProductDetail?.sub_cat?.id && ProductDetail?.sub_cat_detail?.id">
        <app-tata-ok-similar-vehicle [cat_id]="ProductDetail?.cat?.id"  [sub_cat_id]="ProductDetail?.sub_cat?.id" [sub_cat_detail_id]="ProductDetail?.sub_cat_detail?.id" [state]="ProductDetail?.state"></app-tata-ok-similar-vehicle>
    </div>
    <div class="modal fade" id="imageFullScreenModeModal" tabindex="-1" role="dialog"
    aria-labelledby="imageFullScreenModeModalLabel" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 col-sm-12 text-end">
            <button type="button" class="close" (click)="imagePreviewpopupClose()">
              <span aria-hidden="true">
                <img alt="social-close-white" [src]="
                    environment1 + 'images/PDP-Images/social-close-white.svg'
                  " loading="lazy" />
              </span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="viewfullimage">
                <div class="preview text-center w-100">
                  <ngx-slick-carousel #slickHLModal1="slick-carousel" class="carousel popimagepreview gallery2"
                    [config]="popimageSlider">
                    <div ngxSlickItem *ngFor="let item of (ProductDetail?.vehicle_documents.length ? ProductDetail?.vehicle_documents : [{ path: defaultImage }])" class="item">
                      <img style="cursor: pointer" src="{{ item.path }}"
                        class="img-fluid img-sizepopup" loading="lazy" />
                    </div>
                  </ngx-slick-carousel>
                </div>

                <div class="preview-thumb">
                  <ngx-slick-carousel #slickModal1="slick-carousel" class="carousel popimgthumbs"
                    style="width: 445px; margin-left: 166px" [config]="popthumbSlider">
                    <div ngxSlickItem *ngFor="let item of (ProductDetail?.vehicle_documents.length ? ProductDetail?.vehicle_documents : [{ path: defaultImage }])" class="item">
                      <img style="cursor: pointer" src="{{ item.path }}"
                        (click)="changeslide(ProductDetail?.vehicle_documents?.path.indexOf(item))"
                        class="img-fluid" loading="lazy" />
                    </div>
                  </ngx-slick-carousel>
                  <img id="f_image" (click)="prevSlide1()" *ngIf="ProductDetail?.vehicle_documents?.length > 5" style="cursor: pointer"
                     alt="right-blue-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/right-blue-arrow.svg'
                    " />
                  <img id="s_image" (click)="nextSlide1()" *ngIf="ProductDetail?.vehicle_documents?.length > 5" style="cursor: pointer"
                     alt="left-blue-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/left-blue-arrow.svg'
                    " />
                </div>
                <button class="slick-prev .imagepreview .slick-arrow-left ms-4"
                  >
                  <img style="margin-left: 5px; cursor: pointer" alt="right-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/right-arrow.svg'
                    " *ngIf="ProductDetail?.vehicle_documents?.length > 1" (click)="prevSlide1()" />
                </button>
                <button class="slick-next .imagepreview .slick-arrow-right me-5"
                 >
                  <img [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/left-arrow.svg'
                    " *ngIf="ProductDetail?.vehicle_documents?.length > 1" style="margin-left: -8px; cursor: pointer" alt="left-arrow" (click)="nextSlide1()" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
                     <div class="modal fade" id="socialShareModal" tabindex="-1" role="dialog" aria-labelledby="socialShareModalLabel"
                     aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                     <div class="modal-dialog modal-lg" role="document">
                       <div class="modal-content">
                         <div class="modal-header">
                           <div class="col-12 col-sm-12 text-end d-flex">
                             <div class="d-flex share-header">Share this product</div>
                             <button type="button" class="close" style="border: none; background: transparent"
                               (click)="closeSocialSharePopup()">
                               <span aria-hidden="true">
                                 <img alt="social-close-black" [src]="
                                     environment1 + 'images/PDP-Images/social-close-black.svg'
                                   " loading="lazy" />
                               </span>
                             </button>
                           </div>
                         </div>
                         <div class="modal-body">
                           <div class="row">
                             <div class="col-12 col-sm-12">
                               <div class="viewfullimage">
                                 <div class="social-share d-flex" style="justify-content: space-around">
                                   <div>
                                     <a data-toggle="tooltip" title="Twitter" href="https://twitter.com/intent/tweet?url={{
                                         this.pageURL
                                       }}" target="_blank" rel="noopener noreferrer">
                                       <img alt="twitter" [src]="environment1 + 'images/PDP-Images/twitter.svg'" loading="lazy" />
                                     </a>
                                   </div>
                                   <div>
                                     <a data-toggle="tooltip" title="Facebook" href="https://www.facebook.com/sharer.php?u={{
                                         this.pageURL
                                       }}" target="_blank" rel="noopener noreferrer">
                                       <img alt="facebook" [src]="environment1 + 'images/PDP-Images/facebook.svg'" loading="lazy" />
                                     </a>
                                   </div>
                                   <div>
                                     <a data-toggle="tooltip" title="WhatsApp" href="https://wa.me?text={{ this.pageURL }}"
                                       target="_blank" rel="noopener noreferrer">
                                       <img alt="whatsapp" [src]="environment1 + 'assets/images/whatsapp.webp'" width="100%"
                                         height="100%" style="height: 34px" />
                                     </a>
                                   </div>
                                   <div>
                                     <a href="mailto:?subject=Link" data-toggle="tooltip" title="Mail" target="_blank"
                                       rel="noopener noreferrer">
                                       <img alt="mail-to" [src]="environment1 + 'images/PDP-Images/mail-to.svg'" loading="lazy" />
                                     </a>
                                   </div>
                                   <div>
                                     <a data-toggle="tooltip" class="cursor-pointer" title="Copy link" (click)="copyMessage()"
                                       target="_blank" rel="noopener noreferrer">
                                       <img alt="copy-icon" [src]="environment1 + 'images/PDP-Images/copy-icon.svg'" loading="lazy" />
                                     </a>
                                   </div>
                                 </div>
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>


                   <div
                   class="modal fade"
                   id="loginDealer"
                   tabindex="-1"
                   aria-labelledby="loginDealerLabel"
                   aria-hidden="true"
                 >
                   <div class="modal-dialog modal-dialog-centered">
                     <div class="modal-content modaldiv">
                       <div class="modal-header" style="border-bottom: none !important">
                         <h1
                           *ngIf="!disableForm"
                           class="modal-title fs-5"
                           id="loginDealerLabel"
                         >
                           Login With OTP
                         </h1>
                         <button
                           type="button"
                           id="closeBtn1"
                           class="btn-close"
                           data-bs-dismiss="modal"
                           aria-label="Close"
                           aria-hidden="true"
                         ></button>
                       </div>
                       <div
                         class="modal-body text-secondary"
                         style="height: 100% !important; margin-top: 0px; padding-top: 0px"
                       >
                         <div *ngIf="!disableForm">
                           <form [formGroup]="userLoginForm">
                             <div class="col-12 mt-3">
                               <label for="mobileNumber">Contact Info</label>
                               <div class="form-input">
                                 <div class="country-code">
                                   <div class="nation-flag">
                                     <img
                                       alt="Nation Flag"
                                       [src]='environment1 + "assets/images/ind-flag.svg"'
                                       class="img-fluid"
                                       loading="lazy"
                                     />
                                   </div>
                                   +91
                                 </div>
                                 <input
                                   id="mobileNumber"
                                   formControlName="mobile_number"
                                   type="tel"
                                   class="mobile_no"
                                   maxlength="10"
                                   (keypress)="onlyNumberKey($event)"
                                   placeholder="Mobile Number"
                                   numbersOnly
                                   [ngClass]="{
                                     'disabled': userData?.mobile_number
                                   }"
                                 />
                               </div>
                               <div
                                 *ngIf="userLoginForm.controls['mobile_number'].invalid && (userLoginForm.controls['mobile_number'].dirty || userLoginForm.controls['mobile_number'].touched)"
                               >
                                 <div
                                   *ngIf="userLoginForm.controls['mobile_number'].errors?.required"
                                   class="text-danger"
                                 >
                                   Contact number is required.
                                 </div>
                                 <div
                                   *ngIf="userLoginForm.controls['mobile_number'].errors?.pattern"
                                   class="text-danger"
                                 >
                                   Contact number must be 10 digits long.
                                 </div>
                               </div>
                               <div class="form-check mt-2">
                                 <input
                                   class="form-check-input consent-box"
                                   type="checkbox"
                                   id="defaultCheck1" [formControl]="checkBoxControl"
                                   #myCheckbox
                                   (change)="onCheckboxChange(myCheckbox.checked)"
                                 />
                                 <label class="form-check-label" for="defaultCheck1">
                                   Consent to allow TATA Motors to contact you
                                 </label>
                               </div>
                             </div>
                             <div class="col-12 mt-3">
                               <button
                                 class="btn col-6 btn-primary btn-grad-primary btn-brand"
                                 data-bs-toggle="modal"
                                 data-bs-target="#showOtp"
                                 [disabled]="userLoginForm.invalid" 
                                 [ngClass]="{'disabled': !checkBoxcheked}"
                                 (click)="sentOtp()"
                               >
                                 GET CODE
                               </button>
                             </div>
                           </form>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                 
                 
                 
                 <div
                   class="modal fade"
                   id="showOtp"
                   tabindex="-1"
                   aria-labelledby="showOtpLabel"
                   aria-hidden="true" 
                   [hidden]="!(isshowOtp || isshowSignUp)"
                 >
                   <div class="modal-dialog modal-dialog-centered">
                   <div class="modal-content modaldiv" >
                       <div class="close-button" style="border-bottom: none !important">
                         <button
                           type="button"
                           id="closeBtn2"
                           class="btn-close"
                           data-bs-dismiss="modal"
                           aria-label="Close"
                         ></button>
                       </div>
                       <div
                         class="modal-body text-secondary"
                         style="height: 100% !important; margin-top: 0px; padding-top: 0px"
                       >
                       <section *ngIf="isshowOtp">
                         <app-otp (loadParent)="showLogin()"  (loadSignup)="showSignup()"></app-otp>
                       </section>
                       <section *ngIf="isshowSignUp">
                         <app-signup (loadParent)="showLogin()" (loadOtpParent)="showOtp()"></app-signup>
                       </section>
                       </div>
                     </div>
                     
                   </div>
                 </div>
                 
